import { useT } from "../../i18n";

export const Problem = () => {
  const t = useT();
  return (
    <section
      id="problem"
      className="sp-section sp-section--alt"
      data-testid="section-problem"
    >
      <div className="sp-container">
        <div className="sp-reveal">
          <span className="sp-eyebrow">{t.problem.eyebrow}</span>
          <h2 className="sp-title">
            {t.problem.titlePre}
            <br />
            {t.problem.titlePost1}
            <em>{t.problem.titleEm}</em>
            {t.problem.titlePost2}
          </h2>
          <p className="sp-lead">{t.problem.lead}</p>
        </div>

        <div className="sp-problem-grid sp-reveal">
          {t.problem.items.map((it) => (
            <div className="sp-problem-item" key={it.n}>
              <span className="sp-problem-num">{it.n}</span>
              <h3>{it.title}</h3>
              <p>{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
